import React from "react";
import styled from "styled-components";

type PageLinkProps = {
  label: string;
  url: string;
};

export const PageLink = ({ label, url }: PageLinkProps) => {
  const handleClick = () => {
    window.open(url, "_blank");
  };

  return <StyledPageLink onClick={handleClick}>{label}</StyledPageLink>;
};

const StyledPageLink = styled.a`
  font: var(--body-medium-400);
  color: var(--pri-blue-4);
  text-decoration: underline;
  cursor: pointer;
`;
